import React from 'react';
import { getTheme } from '@seller-hermes/theme/theme';
import { i18n } from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { AbbiamoUiHttpConfig } from '@seller-hermes/app/types';
import ConfigContext from '@seller-hermes/app/config.context';
import { QueryClient, QueryClientProvider } from 'react-query';
import { RoutePlanningThemeContext } from '@seller-hermes/theme/context';
import { RecoilRoot } from 'recoil';
import { HermesTheme } from '@seller-hermes/theme/theme';
import { HotkeysProvider } from 'react-hotkeys-hook';

interface Props {
  sellerTheme: HermesTheme;
  i18n: i18n;
  config: AbbiamoUiHttpConfig;
  themeType: 'light' | 'dark';
  children: React.ReactNode;
}

const queryClient = new QueryClient();

const Provider: React.FC<Props> = ({
  i18n,
  themeType = 'light',
  children,
  sellerTheme,
  config,
}) => {
  return (
    <RecoilRoot override>
      <QueryClientProvider client={queryClient}>
        <ConfigContext.Provider value={config}>
          <I18nextProvider i18n={i18n}>
            <HotkeysProvider
              initiallyActiveScopes={['order', 'route', 'csat', 'deliveries']}
            >
              <RoutePlanningThemeContext.Provider
                value={{
                  theme: { ...getTheme(themeType), seller: sellerTheme },
                }}
              >
                {children}
              </RoutePlanningThemeContext.Provider>
            </HotkeysProvider>
          </I18nextProvider>
        </ConfigContext.Provider>
      </QueryClientProvider>
    </RecoilRoot>
  );
};

export default Provider;
